seedWebApp.controller('ContactProductsController', ['$scope', '$rootScope', '$window', '$route','$uibModal', '$timeout', '$filter', '$location', '$routeParams', 'MaterialService', 'ToastService', 'StoreService',
    function ($scope, $rootScope, $window, $route, $uibModal, $timeout, $filter, $location, $routeParams, MaterialService, ToastService, StoreService) {
        console.log('ContactProducts ' + $scope.ContactID);

        $scope.today = new Date();
        $scope.filterString = '';
        $scope.selRoute = {};
        $scope.btnsWidth = '40px';
        $scope.addersTemplate = 'SPA/quotes/quoteAdders.html' + seedWebApp.buildVersion;
        $scope.getMaterialSkus = function () {
            $scope.loadingTotal = true;
            var options = {};
            var skipNumber = 0;
            var takeNumber = 999;
            var sort = null;
            var contactID = $scope.ContactID;
            var filterString = ''; //JRM: FILTRO LOCAL NESTA TELA
            MaterialService.getMaterialSkus(filterString, options, skipNumber, takeNumber, sort, contactID).then(
                function (response) {
                    $scope.loadingTotal = false;
                    if (response) {
                        $scope.items = response.data;
                        $scope.applyFavorites($scope.dash.favorite, $scope.items);
                    }
                },
                function (err) {
                    $scope.loadingTotal = false;
                    var errMsg = '';
                    if (err.data && err.data.ExceptionMessage) {
                        errMsg = err.data.ExceptionMessage;
                    }
                    ToastService.createToast('Error loading', errMsg, 4000, 'error');
                }
            );
        };

        $scope.getSkuFilters = function () {            
            var contactID = $scope.ContactID;
            $scope.loadingFilters = true;
            MaterialService.getSkuFilters(contactID).then(function (response) {
                $scope.loadingFilters = false;
                if (response) {
                    $scope.routes = response.data.routes;
                    $scope.periods = response.data.periods;
                    if ($scope.routes.length) {
                        console.log('findRoute ');
                        var index = $scope.findRoute($scope.routes);
                        if (index < 0) {
                            index = 0;
                        }
                        $scope.selectRoute($scope.routes[index]);
                    }                    
                }
            });
        };

        $scope.findRoute = function (routes) {
            var pointID = $routeParams.route;            
            var index = routes.findIndex(
                function (route) {
                    return route.PointID == pointID;
                }
            );
            return index;
        };

        $scope.loadFavorites = function (contactID) {
            if (!contactID) {
                console.log('CONTACTID UNDEFINED, FAVORITES NOT LOADED');
                return;
            }
            StoreService.getFavorites(contactID).then(
                function (result) {
                    $scope.dash.favorites = result.data;
                }).catch(function (err) {
                    console.log('ErrorLoadingFavorites');
                    console.log(err);
                    ToastService.createToast('Error loading favorites', '', 8000, 'error');
                });
        };

        var selRoute = $routeParams.route;
        console.log('selRoute ' + selRoute);

        $scope.getMaterialSkus();
        $scope.getSkuFilters();
        $scope.loadFavorites($scope.ContactID);

        $scope.getImage = function (country) {
            return '/Images/flags/' + country + '.png';
        };

        $scope.addToCart = function (product) {
            if (product.QtBoxes) {
                $scope.removeCart(product);
            }
            else {
                $scope.addCart($scope.ContactID, product);
            }            
        };

        $scope.selectRoute = function (route) {
            console.log('selectRoute: ' + route.PointID, $scope.periods);
            //console.log(route);
            $scope.selRoute = route;
            $location.search('route', route.PointID);
            
            if (!$scope.periods) {
                return;
            }

            if (!$scope.periods) {
                $scope.periods = [];
            }
            $scope.routePeriods = $scope.periods.filter(function (p) {
                return p.IncotermID == route.IncotermID && p.PointID == route.PointID;
            });
            if ($scope.routePeriods.length) {
                $scope.selectPeriod($scope.routePeriods[0]);
            } 

            /*
            var routePeriod = $scope.periods.find(function (p) {
                return p.IncotermID == route.IncotermID && p.PointID == route.PointID;
            });
            if (routePeriod) {
                $scope.selectPeriod(routePeriod);
            }
            */

            /*
             * $filter NOT WORKING????
             * 
             */
            //console.log($scope.routePeriods);
            //$scope.routePeriods = $filter('filter')($scope.periods, { IncotermID: $scope.selRoute.IncotermID, PointID: $scope.selRoute.PointID });
            //$scope.routePeriods = $filter('filter')($scope.periods, { IncotermID: route.IncotermID, PointID: route.PointID });
            

            /*
            if ($scope.routePeriods.length) {
                $scope.selectPeriod($scope.routePeriods[0]);
            } 
            */
        };

        $scope.selectPeriod = function (period) {
            console.log('selectPeriod');
            //console.log(route);
            $scope.selPeriod = period;            
            $scope.recalcPrices(period);
        };

        $scope.selectSku = function (item) {
            $scope.dash.selectedSkuID = item.SkuID;
            $scope.dash.selProduct = item;
        };


        $scope.recalcPrices = function (selPeriod, forceApi) {
            var recalcMsg = 'Recalculating prices';
            var toastID = ToastService.createToast(recalcMsg, '', 8000, 'wait');
                    
            $scope.recalcMsg = recalcMsg;
            $scope.loadingPrices = true;

            var contactID = $scope.ContactID;
            if (!selPeriod) {
                ToastService.createToast('Select period', '', 2000, 'error');
                return 
            }
            console.log('recalcPrices', selPeriod);

            var incotermID = selPeriod.IncotermID;
            var pointID = selPeriod.PointID;
            var dateStart = selPeriod.DateStart;
            var dateEnd = selPeriod.DateEnd;
            //ZERA PRECOS
            for (var i in $scope.prices) {
                $scope.prices[i].ItemsPrice = null;
            }
            MaterialService.recalcPrices(contactID, incotermID, pointID, dateStart, dateEnd, forceApi).then(
                function (response) {
                    $scope.loadingPrices = false;
                    if (response) {
                        selPeriod.PriceDate = response.data.priceDate;
                        selPeriod.ScopeID = response.data.scopeID;
                        selPeriod.StatusID = response.data.statusID;
                        var pointName = response.data.pointName;
                        $scope.prices = response.data.prices;
                        $scope.dash.logistics = response.data.logistics;
                        $scope.dash.adders = response.data.additionals;
                        $scope.mergePrices($scope.prices, pointName);
                    }
                    ToastService.updateToast(toastID, 'Ok', '', 2000, 'success');
                },
                function (err) {
                    $scope.loadingPrices = false;
                    console.log('Erros recalc prices');
                    console.log(err);
                    var errMsg = '';
                    if (err.data && err.data.ExceptionMessage) {
                        errMsg = err.data.ExceptionMessage;
                    }
                    selPeriod.StatusID = 'Error';
                    ToastService.updateToast(toastID, 'Error calculating', errMsg, 2000, 'error');
                }
            );
        };

        //atualizar também itens do carrinho
        $scope.mergePrices = function (prices, pointName) {
            console.log('merge Prices ' + pointName);
            for (var i = 0; i < prices.length; i++) {
                var price = prices[i];
                var item = $scope.findProduct($scope.items, price.SkuID);                
                if (item) {
                    $scope.mergeItem(item, price, pointName);
                }
                //atualizar apenas para o DESTINO CORRETO
                if ($scope.cartOrder && $scope.cartOrder.Details) {
                    var cartItem = $scope.findProduct($scope.cartOrder.Details, price.SkuID, price.PointID);
                    if (cartItem) {
                        $scope.mergeItem(cartItem, price, pointName);
                        //cartItem.SkuName = '*' + cartItem.SkuName;                                    
                    }
                }
            }
        };

        $scope.mergeItem = function (item, price, pointName) {
            item.ItemsPrice = price.VlPrice;
            item.VlPriceSRecipr = price.VlPriceSRecipr;
            item.VlMbfFinal = price.VlMbfFinal;
            item.VlMbfBase = price.VlMbfBase;
            item.fator = price.fator;
            item.PointID = price.PointID;
            item.PointName = pointName;
            item.VlPriceDesc = price.VlPriceDesc;
            item.VlPriceDescSRecipr = price.VlPriceDescSRecipr;
            item.volume_m3_mbf = price.volume_m3_mbf;
            item.QtdTotalContainer = price.QtdTotalContainer;
            item.perc_hts = price.perc_hts;
            item.reciprocal_tariff = price.reciprocal_tariff;
            item.it_codigo_impar = price.it_codigo_impar;
        };

        $scope.findProduct = function (items, skuID, pointID) {
            var item = items.find(function (p) {
                if (pointID) {
                    if (p.PointID != pointID) {
                        return false;
                    }
                }
                return p.SkuID == skuID;
            });
            return item;
        };

        $scope.showImage = function (product) {
            var modalInstance = $uibModal.open({
                templateUrl: 'SPA/orders/showImageModal.html',
                controller: 'ShowImageCtrl',
                size: 'lg',
                resolve: {
                    product: function () {
                        return product;
                    },
                    contactID: function () {
                        return $scope.ContactID;
                    }
                }
            });
            modalInstance.result.then(function (selectedItem) { });
        };

        $scope.doRefresh = function () {
            console.log('contactProducts.doRefresh()');

            StoreService.resetCache();
            MaterialService.resetCache();
            //$scope.loadContactOrders($scope.ContactID);

            $scope.getMaterialSkus();
            $scope.getSkuFilters();            
        };


        $scope.clearProducts = function (products) {
            for (var i in products) {
                var pro = products[i];
                pro.Quantity = null;
            }
        };


        $scope.$on("clearProducts", function (evt) {
            // handler code here });
            console.log('Limpar produtos');
            $scope.clearProducts($scope.items);
        });

        $scope.toggleSelect = function (item) {
            console.log('toggleSelect');
            item.selected = !item.selected;
        };

        $scope.removeFromFavorites = function (favorite, product) {
            console.log('Remove from favorites');

            var index = favorite.Skus.indexOf(product.SkuID);
            if (index < 0) {
                ToastService.createToast('Item já removido', product.SkuID, 2000, 'error');
                return;
            }
            //if (index >= 0) {
                favorite.Skus.splice(index, 1);
            //}

            var toastID = ToastService.createToast('Removendo', 'Fav', 4000, 'wait');
            StoreService.removeFavoriteSku(favorite.FavoriteID, product.SkuID).then(
                function (response) {
                    ToastService.updateToast(toastID, 'Sku removed', '', 4000, 'success');
                    $scope.applyFavorites(favorite, $scope.items);
                },
                function (err) {
                    console.log(err);
                    ToastService.updateToast(toastID, 'Erro', err.data.ExceptionMessage, 4000, 'error');
                }
            );            
        };

        $scope.addToFavorites = function (item) {
            console.log('add to favorites');
           
            //$scope.dash.favorite = null;
            //VERIFICA SE EXISTE LISTA ATUAL
            var modalInstance = $uibModal.open({
                templateUrl: 'SPA/quotes/skuFavoritesModal.html',
                controller: 'SkuFavoritesModalController',
                size: 'md',
                resolve: {
                    favorites: function () {
                        return $scope.dash.favorites;
                    },
                    favorite: function () {
                        return $scope.dash.addFavorite;
                    },
                    product: function () {
                        return item;
                    },
                    contactID: function () {
                        return $scope.ContactID;
                    }
                }
            });
            modalInstance.result.then(
                function (favorite) {
                    $scope.dash.addFavorite = favorite;
                    $scope.addFavoriteSku(favorite, item);
                    //ToastService.createToast('Produto adicionado na lista', item.SkuID, 2000, 'success');
                }
            );
            
        };

        $scope.addFavoriteSku = function (favorite, product) {
            var toastID = ToastService.createToast('Adicionando', 'Fav', 4000, 'wait');
            StoreService.addFavoriteSku(favorite.FavoriteID, product.SkuID).then(
                function (response) {
                    ToastService.updateToast(toastID, 'Sku added', '', 4000, 'success');
                },
                function (err) {
                    console.log(err);
                    ToastService.updateToast(toastID, 'Erro adicionar', err.data.ExceptionMessage, 4000, 'error');
                }
            );
        };

        $scope.favoriteChanged = function (item) {
            console.log('Favorite changed');
            console.log(item);
            if (item) {
                $scope.applyFavorites(item, $scope.items);
            }
            //console.log($scope.dash.favorite);

        };

        $scope.findFavorite = function (fav, product) {
            if (!fav.Skus) {
                return false;
            }
            var found = fav.Skus.find(function (skuID) {
                return skuID == product.SkuID;
            });
            return found;
        };

        $scope.applyFavorites = function (fav, items) {
            console.log('Apply favorite');
            if (fav) {                
                for (var i in items) {
                    var item = items[i];
                    if (fav.AllItems || !fav.Skus) {
                        item.notFavorite = false;
                    }
                    else if ($scope.findFavorite(fav, item)) {
                        item.notFavorite = false
                    }
                    else {
                        item.notFavorite = true;
                    }
                }                            
            }
            else {
                return true;
            }
        };

        $scope.maxOf = function (val1, val2) {
            return Math.max(val1, val2);
        };

        $scope.hasTariff = function () {
            var product = $scope.dash && $scope.dash.selProduct;
            return !!(product && (product.perc_hts || product.reciprocal_tariff));
        };

        $scope.exportToExcel = function (items) {
            console.log('ExportToExcel');
            ToastService.createToast('Exporting...', '', 4000, 'wait');
            //filtra favoritos
            var details = items.filter(function (d) {
                if (!d.notFavorite) {
                    return d;
                }              
            });
            details = details.map(function (d) {
                var m = {
                    SkuNumber: d.SkuID,
                    SkuName: d.SkuName,                    
                    Drawing: d.DrawingID,
                    Price: d.ItemsPrice,
                    UOM: d.UnitID,
                    UN: d.PriceUnitID,
                    MBFBase: d.VlMbfBase,                      
                    MBFFinal: d.VlMbfFinal,
                    Factor: d.fator,
                    UnitSize: d.pc_cx_un_cli,
                    Size: d.SkuThickness + ' x ' + d.SkuWidth + ' x ' + d.SkuLength,
                    Arrival_Point: d.PointID + ' ' + d.PointName,
                };
                return m;
            });
            var route = $scope.selRoute;
            var fileName = 'Producs_' + route.PointID + '.xlsx';
            alasql('SELECT * INTO XLSX("' + fileName + '", {header:true}) FROM ?', [details]);
        };

        $scope.getDrawingID = function (item) {
            return StoreService.getDrawingID(item);
        };

    }]
);
